import mitt from 'mitt'

const eventBus = mitt()

/* 使用方式

触发事件
eventBus.emit('eventName', eventValue)

监听事件
eventBus.on('eventName', eventValue => {
    console.log(eventValue)
})

移除自定义事件监听
eventBus.all.clear()                    // 移除所有事件监听
eventBus.off('eventName', callback)     // 移除指定事件监听

*/

// 提供事件总线
export default eventBus